import $ from 'jquery';

$.addInit(function(context) {
	var base = '.i-scroll';

	$(base, context).each(function(){
		var component = $(this);

		component.on('click', function(e){
			e.preventDefault();

			var target = $(this).attr('href');
			var fixedOfset = 60;
			$('html,body').stop().animate({ scrollTop: $(target).offset().top - fixedOfset }, 1000);
			$(target).trigger('target');
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/i-scroll.js
// module id = 67
// module chunks = 0